export const data = {
    top_games: [
      {
        game_name: "Gates of Olympus 1000",
        game_id: "vs20olympx",
        provider: "pp-sl",
        icon_url:
          "https://dev-api.prerelease-env.biz/game_pic/rec/325/vs20olympx.png",
      },
      {
        game_name: "Gates of Olympus",
        game_id: "vs20olympgate",
        provider: "pp-sl",
        icon_url:
          "https://dev-api.prerelease-env.biz/game_pic/rec/325/vs20olympgate.png",
      },
      {
        game_name: "Starlight Princess 1000",
        game_id: "vs20starlightx",
        provider: "pp-sl",
        icon_url:
          "https://dev-api.prerelease-env.biz/game_pic/rec/325/vs20starlightx.png",
      },
      {
        game_name: "Sugar Rush 1000",
        game_id: "vs20sugarrushx",
        provider: "pp-sl",
        icon_url:
          "https://dev-api.prerelease-env.biz/game_pic/rec/325/vs20sugarrushx.png",
      },
      {
        game_name: "5 Lions Megaways 2",
        game_id: "vsways5lions2",
        provider: "pp-sl",
        icon_url:
          "https://dev-api.prerelease-env.biz/game_pic/rec/325/vsways5lions2.png",
      },
      {
        game_name: "Speed Baccarat 1",
        game_id: "402",
        provider: "pp-lc",
        icon_url: "https://dev-api.prerelease-env.biz/game_pic/rec/325/402.png",
      },
      {
        game_name: "Mega wheel",
        game_id: "801",
        provider: "pp-lc",
        icon_url: "https://dev-api.prerelease-env.biz/game_pic/rec/325/801.png",
      },
      {
        game_name: "Sweet Bonanza Candyland",
        game_id: "1101",
        provider: "pp-lc",
        icon_url: "https://dev-api.prerelease-env.biz/game_pic/rec/325/1101.png",
      },
    ],
    providers: [
      {
        provider: "pp-sl",
        banner_url: "https://file.burmeseslot.com/uiImages/pp-sl-banner.png",
        icon_url: "",
      },
      {
        provider: "pp-lc",
        banner_url: "https://file.burmeseslot.com/uiImages/pp-lc-banner.png",
        icon_url: "",
      },
      {
        provider: "pp-fp",
        banner_url: "https://file.burmeseslot.com/uiImages/pp-fp-banner.png",
        icon_url: "",
      },
      {
        provider: "uu-sl",
        banner_url: "https://file.burmeseslot.com/uiImages/uu-sl-banner.png",
        icon_url: "",
      },
      {
        provider: "l22",
        banner_url: "https://file.burmeseslot.com/uiImages/l22-banner.png",
        icon_url: "",
      },
    ],
  };
  